import { environment } from "./environment";

export const apiUrls = {
	accessToken: 		`${environment.api}/Update/security/auth`,
	publicRSAKey: 		`${environment.api}/Update/security/safe-data/generate/values`,
	verifyUUID: 		`${environment.api}/Update/security/client-all`,
	onfido: 			`${environment.api}/Update/Security/App/hybrid-security/onfido-process`,
	updateProfile: 		`${environment.api}/Update/Client`,
	address: 			`${environment.api}/Update/Client/address`,
	financieInfo: 		`${environment.api}/Update/Client/finance-info`,
	presignedUrl: 		`${environment.api}/Update/Document/presigned-url`,
	uploadAppianFile:   `${environment.api}/Update/Document/upload-appian-file`,
	cryptoInfo: 		`${environment.api}/Update/Client/crypto-info`,
	appianProcess:      `${environment.api}/Update/Security/App/appian-process`,
};